import $ from "jquery";
import Swiper from "swiper";

import {
  Mousewheel,
  EffectCreative,
  Navigation,
  Pagination,
  Grid,
} from "swiper/modules";

export default class LargeLogoCarousel {
  $el = $("section.large-logo-carousel");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.setupCarousel();
  }

  setupCarousel() {
    Swiper.use([Mousewheel, EffectCreative, Navigation, Pagination, Grid]);

    const $carousel = this.$el.find(".swiper").get(0);
    const $swiperNext = this.$el.find(".carousel-next").get(0);
    const $swiperPrev = this.$el.find(".carousel-prev").get(0);
    const $pagination = this.$el.find(".carousel-pagination").get(0);

    new Swiper($carousel, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      //Slides to scroll.
      loop: true,
      speed: 1000,
      loopAddBlankSlides: true,
      navigation: {
        nextEl: $swiperNext,
        prevEl: $swiperPrev,
      },
      pagination: {
        el: $pagination,
        clickable: true,
        // Classes.
        bulletClass:
          "w-4 h-4 inline-block border border-grape-juice rounded-full ml-2",
        bulletActiveClass: "bg-grape-juice",
      },
      autoplay: {
        delay: 2000,
      },
      grid: {
        rows: 3,
        fill: "row",
      },
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 6,
          slidesPerGroup: 2,

          grid: {
            rows: 3,
          },
        },
      },
    });
  }
}
